import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const GroupIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M19.82 5.42C19.82 7.06 18.5 8.36 16.86 8.36C15.22 8.36 13.9 7.06 13.9 5.42C13.9 3.78 15.22 2.48 16.86 2.48C18.5 2.48 19.82 3.78 19.82 5.42ZM16.86 6.84C17.62 6.84 18.26 6.22 18.26 5.42C18.26 4.62 17.62 4 16.86 4C16.1 4 15.46 4.62 15.46 5.42C15.46 6.22 16.1 6.84 16.86 6.84ZM10.1 9.62C10.1 11.26 8.78 12.56 7.14 12.56C5.5 12.56 4.18 11.26 4.18 9.62C4.18 7.98 5.5 6.68 7.14 6.68C8.78 6.68 10.1 7.98 10.1 9.62ZM7.14 11.04C7.9 11.04 8.54 10.42 8.54 9.62C8.54 8.82 7.9 8.2 7.14 8.2C6.38 8.2 5.74 8.82 5.74 9.62C5.74 10.42 6.38 11.04 7.14 11.04ZM16.86 9.14C19.78 9.14 22 11.6 22 14.8H11.72C11.72 11.6 13.94 9.14 16.86 9.14ZM16.86 10.72C15.24 10.72 13.8 11.82 13.58 13.34H20.14C19.92 11.82 18.5 10.72 16.86 10.72ZM7.14 13.34C10.06 13.34 12.28 15.8 12.28 19H2C2 15.8 4.22 13.34 7.14 13.34ZM7.14 14.92C5.52 14.92 4.08 16.02 3.86 17.54H10.42C10.2 16.02 8.78 14.92 7.14 14.92Z" />
    </SvgIcon>
  );
});
